import dataPreservations from "./DataPreservationReducer";

const dataPreservation = {
    reducers: dataPreservations
}

export default dataPreservation;